/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { createQueryOptions, createMutationFn } from '@shared/lib/api';
import { 
  UserSettingsData, 
  ChatSettings, 
  UISettings, 
  AgentSettings, 
  LearningSettings, 
  NotificationSettings,
  IntegrationSettings,
  UpdateSettingsCategoryRequest 
} from '@shared/types/user_settings';

// Get user settings
export const getUserSettings = createQueryOptions<UserSettingsData>('/api/settings/users');

// Update full settings
export const updateUserSettings = createMutationFn<UserSettingsData, Partial<UserSettingsData>>('/api/settings/users', 'PUT');

// Update specific settings category
export const updateSettingsCategory = createMutationFn<UserSettingsData, UpdateSettingsCategoryRequest>('/api/settings/users/category', 'PUT');

// Delete/reset settings
export const deleteUserSettings = createMutationFn<{ message: string }, void>('/api/settings/users', 'DELETE');

// Convenience functions for specific categories
export const updateChatSettings = (settings: ChatSettings) => 
  updateSettingsCategory({ category: 'chatSettings', settings });

export const updateUISettings = (settings: UISettings) => 
  updateSettingsCategory({ category: 'uiSettings', settings });

export const updateAgentSettings = (settings: AgentSettings) => 
  updateSettingsCategory({ category: 'agentSettings', settings });

export const updateLearningSettings = (settings: LearningSettings) => 
  updateSettingsCategory({ category: 'learningSettings', settings });

export const updateNotificationSettings = (settings: NotificationSettings) => 
  updateSettingsCategory({ category: 'notificationSettings', settings });

export const updateIntegrationSettings = (settings: IntegrationSettings) => 
  updateSettingsCategory({ category: 'integrationSettings', settings });
